import axios from 'axios';
import config from '../config/config';
import { store } from '../store';
import { loginFailed } from '../store/slices/authSlice';
import * as CryptoJS from 'crypto-js';
// axios.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     console.error(error.response);
//     if (error?.response?.status === 401 || error?.response?.status === 400) {
//       localStorage.removeItem('user');
//       Promise.reject(error);
//       // return error.response;
//       // window.location.href = '/login';
//     }
//   }
// );

const SECRET_KEY = 'testingencryptionkey';

function decryptData(encryptedString) {
  const bytes = CryptoJS.AES.decrypt(encryptedString, SECRET_KEY);
  const decrypted = bytes.toString(CryptoJS.enc.Utf8);
  return JSON.parse(decrypted);
}

const { baseUrl } = config;
const getHeaders = () => {
  const state = store.getState();
  let user = state.authReducer.data;
  if (!user) return {};
  return { Authorization: `Bearer ${user.token}` };
};
const handleError = (error) => {
  let response = '';
  if (error?.response?.status === 401) {
    store.dispatch(loginFailed());
    //localStorage.removeItem("user");
    // const location = window.location.href;
    // if (!(location.includes('/login') || location.includes('/signup'))) {
    //   window.location.href = '/login';
    // }
    window.location.href = '/';
  }
  if (error.response) {
    response = error.response.data.message;
  } else if (error.request) {
    response = error.request.toString();
  } else {
    response = error.message;
  }
  throw new Error(response);
};
const httpRequest = async (method, url, data = '', headers = {}) => {
  let config = { method, url, headers: { ...getHeaders(), ...headers } };
  if (data) {
    config = { ...config, data };
  }
  try {
    const results = await axios(config);
    // console.log('res: ', decryptData(results.data.encrypted));
    return decryptData(results.data.encrypted);
    // return results.data;
  } catch (error) {
    handleError(error);
  }
};
export const getRequest = (url) => httpRequest('get', baseUrl + '/' + url);
export const deleteRequest = (url) =>
  httpRequest('delete', baseUrl + '/' + url);
export const postRequest = (url, data, options = {}) =>
  httpRequest('post', baseUrl + '/' + url, data, options);
export const patchRequest = (url, data) =>
  httpRequest('patch', baseUrl + '/' + url, data);
